/**
 * Retrieve the width of the string.
 * @param  {String}         text            Text to be measured
 * @param  {String}         font            Text font
 * @param  {HTMLElement}    canvasElement   Optional. Useful to cache canvas when calling this method repeatedly
 * @return {Number}
 */
const getTextWidth = (text, font, canvasElement) => {
    const canvas = canvasElement || document.createElement('canvas');
    const context = canvas.getContext('2d');
    let width;

    context.font = font;

    width = Math.floor(context.measureText(text).width);
    // Width may be 0, in that case we don't want to add 1 px.
    return width ? width + 1 : width;
};

module.exports = {
    getTextWidth
};
